import { format } from 'date-fns'

export const formatTime = (seconds: number) => {
  const date = new Date(seconds * 1000)
  return format(date, 'ss')
}

export const formatDate = (dateString: string, formatString: string) => {
  try {
    const date = new Date(dateString)
    return format(date, formatString)
  } catch (error) {
    console.error('Error formatting date:', error)
    return ''
  }
}
